import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "TrainingTest" })
export default class TrainingTest extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public trainingTestData: any = null;
    public formData: any = {};
    public validationErrors: any[] = [];

    get isTrainingTestVisible() {
        return this.$store.getters["myTrainingStore/isTrainingTestVisible"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    @Prop() readonly trainingCourseIdMaster: string;

    @Watch("isTrainingTestVisible") onIsTrainingTestVisible(newValue: boolean) {
        if (newValue) {
            this.getData();
        }
    }

    public async getData() {
        this.trainingTestData = (await Axios.post(this.routes.MyBremboPartsTraining_GetTrainingTestData, { trainingCourseIdMaster: this.trainingCourseIdMaster })).data;

        this.$nextTick(function () {
            (<any>this).$refs.testRef.scrollIntoView({ behavior: "smooth", block: "start" });
        });
    }

    public closeTest() {
        this.$store.commit("myTrainingStore/setTrainingTestVisible", false);
    }

    public closeTestAndRefresh() {
        location.reload();
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        this.formData.trainingCourseIdMaster = this.trainingCourseIdMaster;

        try {
            const result = (await Axios.post(this.routes.MyBremboPartsTraining_SetTrainingTest, this.formData)).data;

            if (result.isTestSuccess) {
                GTagHelper.sendEvent("form_submit", "course_result", "success");

                this.trainingTestData.isTestSuccess = true;
            } else {
                GTagHelper.sendEvent("form_submit", "course_result", "failed");

                await this.getData();
                this.formData = {};
            }
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public downloadCertificate() {
        window.location.href = this.routes.MyBremboPartsTraining_DownloadCertificate + "?trainingCourseId=" + this.trainingCourseIdMaster;
    }
};